import { periodSelectionTypes } from '@app/insights/types'
import type { ColumnName } from '@app/insights/store/filters/types'

interface ActiveFilter {
  uuid?: string
  id?: unknown
  type: string
  settings: Record<string, unknown>
  columnName?: ColumnName
  [key: string]: unknown
}

interface FilterDefinition {
  serializeSettings?: (
    settings: Record<string, unknown>
  ) => Record<string, unknown>
  [key: string]: unknown
}

interface FilterSettingsOptions {
  includeId?: boolean
  includeUuid?: boolean
}

interface SerializedFilter {
  type: string
  params: Record<string, unknown>
  column_name: ColumnName | undefined
  uuid?: string
  id?: unknown
}

interface LedgerSelectParams {
  periodSelection: string | null
  ledgerSelectDate: string | null
  ledgerSelectLockType: string | null
}

const serialize = {
  filterSettings(
    activeFilters: ActiveFilter[],
    allFiltersByType: Record<string, FilterDefinition>,
    { includeId = true, includeUuid = true }: FilterSettingsOptions = {}
  ): SerializedFilter[] {
    return activeFilters.map((filter) => {
      const { type, settings, columnName } = filter
      const filterType = allFiltersByType[type]

      const serializedFilter: SerializedFilter = {
        type,
        params: filterType?.serializeSettings?.(settings) ?? {},
        column_name: columnName,
      }

      if (includeUuid) {
        serializedFilter.uuid = filter.uuid
      }

      // mixing uuid/id until it's clear if we could rely purely on uuid and use it as a PK
      if (includeId && filter.id) {
        serializedFilter.id = filter.id
      }

      return serializedFilter
    })
  },

  ledgerSelectSettings({
    periodSelection,
    ledgerSelectDate,
    ledgerSelectLockType,
  }: LedgerSelectParams): Record<string, unknown> {
    let params: Record<string, unknown> = {}

    switch (periodSelection) {
      case periodSelectionTypes.FINANCIAL_YEAR:
        params = { financial_year: true, date: ledgerSelectDate }
        break
      case periodSelectionTypes.ACCOUNTING_PERIOD:
        params = { accounting_period: true, date: ledgerSelectDate }
        break
      case periodSelectionTypes.FINANCIAL_YEAR_EXACT_DATE:
        params = { financial_year_exact_date: true, date: ledgerSelectDate }
        break
      case periodSelectionTypes.ACTIVE_PERIOD:
        params = { active_period: true, locking_type: ledgerSelectLockType }
        break
      case periodSelectionTypes.COMPLETED_PERIOD:
        params = { completed_period: true, locking_type: ledgerSelectLockType }
        break
    }

    return params
  },
}

export default serialize
